/* eslint semi:0 */
import 'core-js'
import '../../jsCore/application/bootstrap_post_page'
import React from 'react'
import { renderReact } from 'hypernova-react'
import { mountAll } from '../../jsCore/utils/component'
import { mountAll as rMountAll } from '../../jsCore/utils/rComponent'
import navbarComponent from '../../jsCore/organizedByType/components/navbarComponent'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import userToolbarComponent from '../../jsCore/organizedByType/components/userToolbarComponent'
import googleSearchComponent from '../../jsCore/organizedByType/components/googleSearchComponent'
import { getIsEmbededPost } from '../../jsCore/application/pageDataObject'
import initializeEditionSelection from '../../components/edition_dropdown/editionDropdown'
import trackAnalyticsClickEvents from '../../components/track_analytics_click_events/trackAnalyticsClickEvents'
import { trackAnalyticsYoutubeEvents } from '../../components/track_analytics_youtube_events/trackAnalyticsYoutubeEvents'
import { registerExternalScripts } from '../../components/viewability/externalScriptsViewabilityRegistration'
import { trackGoogleAnalyticsSessionId } from '../../components/googleAnalyticaSessionTracker/googleAnalyticaSessionTracker'
import { injectFreshEight } from '../../components/fresh8/freshEightInjector'
import { taboolaFeedEventsReporter } from '../../components/taboolaFeedEventsTracker/taboolaFeedEventsTracker'
//redux
import initCookieDisclaimer from '../../components/cookieDisclaimer/cookieDisclaimerContainer'
import initPostMetadataStats from '../../components/post_metadata/postMetadataContainer'
import initSocialBarComponents from '../../components/reactions/socialBarContainer'
import initCommunityDisclaimer from '../../components/community_disclaimer/communityDisclaimerContainer'
import initMontiPlayers from '../../components/monti/montiContainer'
import { initSocialButtons } from '../../components/social_buttons/socialButtons.container'
import initRecommendedVideos from '../../components/recommendedVideos/recommendedVideos.container'
import { initCommonComponents } from '../common/common'
import { TransferNewsContainer } from '../../components/transfer_news/transferNews.container'
import { ArticleImageContainer } from '../../components/article_image/articleImage.container'
import { PostActionsContainerWithStore } from '../../components/post_actions/postActionsWithStore.container'
import { initRecommendedPosts } from '../../components/recommendedPosts/recommendedPostsWithStoreContainer'
import { markTiming } from '../../jsCore/utils/performanceTimings'
import { getVideoAdsTag } from '../../jsCore/organizedByType/vms/ads/videoAdTag'
markTiming('start post page javascript')
initializeEditionSelection()
mountAll({
  // TODO: instead of using css classes as selectors we should do something like data-mount-component
  [MOUNT_POINTS.SEARCH_COMPONENT]: googleSearchComponent,
  [MOUNT_POINTS.NAVBAR_SOCIAL_COMPONENT]: navbarComponent,
  [MOUNT_POINTS.USER_MENU_DROPDOWN]: userToolbarComponent,
})

trackGoogleAnalyticsSessionId()
initCookieDisclaimer(!getIsEmbededPost())
initPostMetadataStats()
initSocialBarComponents()
initCommunityDisclaimer()
initMontiPlayers()
trackAnalyticsClickEvents()
initSocialButtons()
trackAnalyticsYoutubeEvents()
initRecommendedVideos()
initCommonComponents()
getVideoAdsTag()
initRecommendedPosts()
renderReact('TransferNewsContainer', TransferNewsContainer)
renderReact('ArticleImageContainer', ArticleImageContainer)
renderReact('PostActionsContainer', PostActionsContainerWithStore())
registerExternalScripts()
injectFreshEight()
taboolaFeedEventsReporter()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/postPage/postPage.js